import {
	FormControl,
	FormControlProps,
	FormHelperText,
	FormLabel,
	InputLabel,
	InputProps,
	Select as MuiSelect,
	SelectProps,
} from '@mui/material';
import { forwardRef, ReactNode } from 'react';
import { Control, Controller, ControllerProps } from 'react-hook-form';

interface FieldProps extends Partial<ControllerProps> {
	name: string;
	control: Control<any>;
	children?: ReactNode;
	render?: any;
	label?: string;
	selectProps?: SelectProps;
	formControlProps?: FormControlProps;
}

const Select = forwardRef<HTMLDivElement, FieldProps>(
	({ label, formControlProps, selectProps, ...props }, ref) => {
		return (
			<Controller
				{...props}
				name={props.name}
				control={props.control}
				render={({ field, fieldState }) => (
					<FormControl
						{...field}
						{...formControlProps}
						error={Boolean(fieldState.error)}
						ref={ref}
						variant="filled"
						fullWidth
					>
						<InputLabel
							id={(selectProps?.id ?? props.name) + '-label'}
							htmlFor={selectProps?.id ?? props.name}
						>
							{label}
						</InputLabel>

						<MuiSelect
							{...selectProps}
							id={selectProps?.id ?? props.name}
							labelId={(selectProps?.id ?? props.name) + '-label'}
							value={field.value}
							label={label}
							onChange={(event) => field.onChange(event)}
						>
							{props.children}
						</MuiSelect>

						{fieldState.error && (
							<FormHelperText>{fieldState.error.message}</FormHelperText>
						)}
					</FormControl>
				)}
			/>
		);
	}
);

export default Select;
